export const translations = {
  en: {
    nav: {
      services: 'Services',
      whyUs: 'Why Us',
      contact: 'Contact',
      imprint: 'Imprint',
      privacy: 'Privacy Policy'
    },
    hero: {
      badge: 'Pharmaceutical Consulting',
      title: 'Chalhoub Trade',
      subtitle: 'Connecting Health Globally',
      description: 'Professional pharmaceutical consulting and sourcing expertise from Germany. As a strategic intermediary, we provide global healthcare providers, particularly in the MENA region, with access to high-quality German pharmaceuticals and medical products.',
      cta: 'Request a feasibility check',
      disclaimer: 'Chalhoub Trade acts exclusively as an independent pharmaceutical intermediary and does not buy, sell, store, or ship medicinal products.'
    },
    services: {
      title: 'Our Core Services',
      subtitle: 'Comprehensive pharmaceutical consulting and supply chain solutions tailored to your needs.',
      service1: {
        title: 'Sourcing & Brokerage of German Pharmaceuticals',
        description: 'We specialize in brokering access to high-quality, German-manufactured pharmaceuticals and medical devices. Through our network of GDP-certified manufacturers and wholesalers, we enable international healthcare providers to gain direct access to original medications and innovative medical solutions, without detours.',
        features: [
          'Access to German Brands: Direct brokerage of authentic products from the German market to international importers.',
          'Negotiation & Coordination: Securing competitive terms through professional pharmaceutical expertise and market insight.',
          'Supplier Verification: Ensuring all trading partners meet the highest European safety standards and licensing requirements.'
        ]
      },
      service2: {
        title: 'Regulatory & Compliance Advisory',
        description: 'International pharmaceutical trade is governed by complex legal frameworks. We provide expert guidance to ensure that every transaction is fully compliant with both German export laws and international and local import regulations.',
        features: [
          'Documentation Management: Preparation of CO, CoA, CPP, and Export Declarations to ensure smooth customs clearance in the destination country.',
          'Market Entry Support: Consulting on local registration requirements and regulatory hurdles.',
          'Supplier Verification: Ensuring all trading partners meet the highest European safety standards and licensing requirements (GDP/GMP compliance check).'
        ]
      },
      service3: {
        title: 'Supply Chain Coordination & Logistics Oversight',
        description: 'A medication is only effective if it arrives safely. We coordinate the sensitive logistics of international pharmaceutical transport by selecting certified partners. Our focus is on monitoring the supply chain from the manufacturer to the end destination to ensure the highest standards.',
        features: [
          'Cold Chain Integrity: Oversight of temperature requirements (2-8°C / 15-25°C) through specialized GDP-compliant logistics partners.',
          'Incoterm Optimization: Consulting on ideal shipping terms (FCA, CPT, DAP) to efficiently balance cost and risk between buyer and seller.',
          'Inspection Management: Commissioning and coordinating independent pre-shipment inspections via international agencies (e.g., SGS, Bureau Veritas) on behalf of the customer.'
        ]
      }
    },
    whyPartner: {
      title: 'Why Partner with Chalhoub Trade?',
      subtitle: 'Chalhoub Trade acts as a specialized interface between German exporters and international healthcare providers. We do not trade goods, we deliver solutions: we identify sources, assess regulatory feasibility, and coordinate the process for you.',
      reason1: {
        title: 'Pharmacist-Led Expertise',
        description: 'As a pharmacist licensed in both Germany and Syria, Sami Chalhoub provides a level of regulatory and pharmaceutical-legal insight that standard trading companies cannot offer.'
      },
      reason2: {
        title: 'The "Made in Germany" Advantage',
        description: 'Based in Fürth, we operate in one of the world\'s most regulated and respected pharmaceutical environments.'
      },
      reason3: {
        title: 'Reliability & Transparency',
        description: 'We build long-term partnerships based on ethical business practices and clear, service-oriented communication.'
      },
      reason4: {
        title: 'Global Vision',
        description: 'Our mission is to bridge the gap between European medical excellence and global healthcare needs. We place a special focus on the MENA region.'
      },
      compliance: 'All projects are assessed case by case. We apply EU sanctions screening, KYC checks, and end use verification for all involved parties.',
      scope: 'We focus on finished medicinal products and do not support controlled substances, dual use sensitive goods, or circumvention structures.'
    },
    contact: {
      title: 'Feasibility Request',
      subtitle: 'For an initial assessment, please include the details below.',
      address: 'Address',
      addressValue: 'Mohrenstrasse 5, 90762 Fuerth, Germany',
      phone: 'Phone',
      email: 'Email',
      feasibilityLink: 'Request a feasibility check',
      checklistItems: [
        'Target country and city',
        'Importer type and company name',
        'Short product list, up to 10 items',
        'Expected volume and preferred currency'
      ],
      languageDisclaimer: 'English is preferred for the initial assessment.'
    },
    imprint: {
      title: 'Imprint',
      responsible: 'Responsible',
      contact: 'Contact Information',
      tax: 'Tax Information',
      vatLabel: 'VAT number',
      dispute: 'Dispute Resolution',
      disputeConsumerLabel: 'Consumer dispute resolution',
      disputeConsumerText: 'We are not willing or obliged to participate in dispute resolution proceedings before a consumer arbitration board.',
      professional: 'Professional Legal Information',
      professionalJobTitle: 'Job Title',
      professionalJobTitleText: 'Pharmacist (licensed in the Federal Republic of Germany and the Syrian Arab Republic)',
      professionalAuthority: 'Competent Chamber',
      professionalAuthorityText: 'Bayerische Landesapothekerkammer, Maria-Theresia-Straße 28, 81675 München, Deutschland',
      professionalAuthorityWebsite: 'www.blak.de',
      professionalSupervisoryAuthority: 'Supervisory Authority',
      professionalSupervisoryAuthorityText: 'Regierung von Mittelfranken, Promenade 27, 91522 Ansbach',
      professionalRegulations: 'Regulations',
      professionalRegulationsText: 'Professional Code for Pharmacists (available on the website of the relevant chamber of pharmacists).'
    },
    privacy: {
      title: 'Privacy Policy',
      section1Title: 'Controller & Contact',
      section1Text: 'Sami Chalhoub\nMohrenstrasse 5, 90762 Fuerth, Germany\nEmail: sami.chalhoub@chalhoubtrade.de\nPhone: +49 152 2657 3461',
      section2Title: 'Website Provision & Security',
      section2Text: 'This website uses SSL/TLS encryption for security reasons and to protect the transmission of confidential content.\n\nThis website is hosted externally. The hosting provider automatically stores server log files (IP address, browser type, timestamp).\n\nWe use only technically necessary cookies for operating the website (no marketing/tracking).\n\nLegal basis: Art. 6(1)(f) GDPR.',
      section3Title: 'Data Use & Storage',
      section3Text: 'Data submitted via contact inquiries is processed on the basis of Art. 6(1)(b) GDPR.\n\nData is stored only for as long as necessary for the purpose of collection or as required by statutory retention obligations.',
      section4Title: 'Your Rights & Complaint',
      section4Text: 'You have the right of access, rectification, and erasure, as well as the right to restriction of processing, the right to data portability, and the right to object.\n\nYou also have the right to lodge a complaint with the competent supervisory authority. The competent authority is, in particular, the Bavarian State Office for Data Protection Supervision (BayLDA).'
    },
    footer: {
      slogan: 'Connecting Health Globally',
      description: 'Premium pharmaceutical consulting and global sourcing solutions from Germany.',
      quickLinks: 'Quick Links',
      contactInfo: 'Contact Information',
      addressText: 'Mohrenstrasse 5\n90762 Fuerth\nGermany',
      copyright: '©',
      allRights: 'All rights reserved.'
    }
  },
  ar: {
    nav: {
      services: 'الخدمات',
      whyUs: 'ماذا يميزنا',
      contact: 'تواصل معنا',
      imprint: 'إشعار قانوني',
      privacy: 'سياسة الخصوصية'
    },
    hero: {
      badge: 'استشارات دوائية',
      title: 'Chalhoub Trade',
      subtitle: 'نربط الصحة عالمياً',
      description: 'استشارات صيدلانية مهنية وخبرة في التوريد من ألمانيا. بصفتنا وسيطاً استراتيجياً، نتيح لمقدمي الرعاية الصحية العالميين، ولا سيما في منطقة الشرق الأوسط وشمال أفريقيا، الوصول إلى الأدوية والمنتجات الطبية الألمانية عالية الجودة.',
      cta: 'طلب تقييم الجدوى',
      disclaimer: 'تعمل Chalhoub Trade حصريا كوسيط مستقل في مجال الأدوية ولا تقوم بشراء أو بيع أو تخزين أو شحن المنتجات الدوائية.'
    },
    services: {
      title: 'خدماتنا الأساسية',
      subtitle: 'حلول شاملة للاستشارات الدوائية وتأمين المصادر وتنسيق سلسلة الإمداد مُصمّمة لتلبية احتياجاتكم.',
      service1: {
        title: 'تأمين المصادر ووساطة الأدوية الألمانية',
        description: 'نختص في وساطة إتاحة الوصول إلى أدوية ومنتجات طبية ألمانية عالية الجودة. بالاعتماد على شبكة واسعة من المصنّعين وتجار الجملة المعتمدين وفق نظام GDP العالمي، نُمكّن مزوّدي الرعاية الصحية الدوليين من الوصول المباشر إلى الأدوية الأصلية والحلول الطبية المبتكرة، دون عوائق.',
        features: [
          'الوصول إلى العلامات الألمانية: وساطة مباشرة لمنتجات أصلية من السوق الألماني إلى المستوردين الدوليين.',
          'التفاوض والتنسيق: تأمين شروط تنافسية عبر خبرة دوائية احترافية ومعرفة بالسوق.',
          'التحقق من المورّدين: ضمان أن جميع الشركاء يستوفون أعلى معايير السلامة الأوروبية والمتطلبات الترخيصية.'
        ]
      },
      service2: {
        title: 'الاستشارات التنظيمية والامتثال القانوني',
        description: 'تخضع التجارة الدوائية الدولية لأطر قانونية معقّدة. نقدم إرشادات متخصصة لضمان امتثال كل معاملة لقوانين التصدير الألمانية ومتطلبات الاستيراد الدولية و المحلية.',
        features: [
          'إدارة الوثائق: إعداد شهادات المنشأ (CO)، وشهادات التحليل (CoA)، وشهادة المنتج الصيدلاني (CPP)، وبيانات التصدير لضمان تخليص جمركي سلس في بلد الوجهة.',
          'دعم دخول الأسواق: استشارات حول متطلبات التسجيل المحلية والتحديات التنظيمية.',
          'التحقق من المورّدين: ضمان أن جميع الشركاء يستوفون أعلى معايير السلامة الأوروبية ومتطلبات التراخيص (فحص التوافق مع GDP/GMP).'
        ]
      },
      service3: {
        title: 'تنسيق سلسلة التوريد والرقابة اللوجستية',
        description: 'لا تكون الأدوية فعّالة إلا إذا وصلت بأمان. ننسّق لوجستيات النقل الدوائي الدولي الحسّاسة عبر اختيار شركاء معتمدين. ينصبّ تركيزنا على مراقبة سلسلة الإمداد من المصنع حتى الوجهة النهائية لضمان أعلى المعايير.',
        features: [
          'سلامة سلسلة التبريد: مراقبة متطلبات درجات الحرارة (2-8 درجة مئوية / 15-25 درجة مئوية) من خلال شركاء لوجستيين متخصصين متوافقين مع معايير التوزيع الجيد (GDP).',
          'تحسين شروط التجارة الدولية (Incoterms): تقديم مشورة استراتيجية حول شروط الشحن المثلى (مثل FCA, CPT, DAP) لتحقيق توازن فعال بين التكلفة والمخاطر لكل من البائع والمشتري.',
          'إدارة التفتيش: تكليف وتنسيق عمليات فحص مستقلة قبل الشحن عبر جهات دولية (مثل SGS, Bureau Veritas) نيابةً عن العميل.'
        ]
      }
    },
    whyPartner: {
      title: 'ما يميزنا في Chalhoub Trade؟',
      subtitle: 'تعمل Chalhoub Trade كحلقة وصل متخصصة بين المصدّرين الألمان ومزوّدي الرعاية الصحية الدوليين. نحن لا نتاجر بالسلع، بل نقدّم حلولاً: نحدد مصادر التوريد، نقيّم الإمكانية التنظيمية، وننسّق العملية من أجلك.',
      reason1: {
        title: 'خبرة يقودها صيدلاني مرخص',
        description: 'بصفته صيدلانياً مرخصاً في كل من ألمانيا وسوريا، يقدّم الصيدلي سامي شلهوب مستوى من الفهم التنظيمي والدوائي القانوني لا توفره شركات التجارة التقليدية.'
      },
      reason2: {
        title: 'ميزة "صنع في ألمانيا"',
        description: 'انطلاقاً من مقرّنا في بافاريا الألمانية، نعمل ضمن واحدة من أكثر البيئات الدوائية تنظيماً واحتراماً على مستوى العالم.'
      },
      reason3: {
        title: 'الموثوقية والشفافية',
        description: 'نبني شراكات طويلة الأمد على أساس ممارسات تجارية أخلاقية وتواصل واضح يركز على الخدمة.'
      },
      reason4: {
        title: 'رؤية عالمية',
        description: 'مهمتنا هي بناء جسر يربط بين التميز الطبي الأوروبي واحتياجات الرعاية الصحية العالمية. ونحن نركز بشكل خاص على منطقة الشرق الأوسط وشمال أفريقيا.'
      },
      compliance: 'يتم تقييم جميع المشاريع على أساس كل حالة على حدة. نقوم بتطبيق فحوصات عقوبات الاتحاد الأوروبي وإجراءات اعرف عميلك والتحقق من الاستخدام النهائي لجميع الأطراف المعنية.',
      scope: 'نركز على المنتجات الدوائية النهائية ولا ندعم المواد الخاضعة للرقابة أو السلع الحساسة ذات الاستخدام المزدوج أو أي هياكل تهدف إلى التحايل.'
    },
    contact: {
      title: 'طلب تقييم الجدوى',
      subtitle: 'لإجراء تقييم أولي يرجى تضمين التفاصيل الموضحة أدناه.',
      address: 'العنوان',
      addressValue: 'Mohrenstrasse 5, 90762 Fuerth, Germany',
      phone: 'الهاتف',
      email: 'البريد الإلكتروني',
      feasibilityLink: 'طلب تقييم الجدوى',
      checklistItems: [
        'الدولة المستهدفة والمدينة',
        'نوع المستورد واسم الشركة',
        'قائمة منتجات مختصرة، حتى 10 أصناف',
        'الكمية المتوقعة والعملة المفضلة'
      ],
      languageDisclaimer: 'يفضل استخدام اللغة الإنجليزية للتقييم الأولي.'
    },
    imprint: {
      title: 'إشعار قانوني',
      responsible: 'المسؤول',
      contact: 'معلومات التواصل',
      tax: 'معلومات ضريبية',
      vatLabel: 'VAT number',
      dispute: 'تسوية النزاعات',
      disputeConsumerLabel: 'تسوية نزاعات المستهلك',
      disputeConsumerText: 'لسنا مستعدين أو ملزمين بالمشاركة في إجراءات تسوية النزاعات أمام هيئة تحكيم للمستهلكين.',
      professional: 'المعلومات المهنية والقانونية',
      professionalJobTitle: 'المسمى الوظيفي القانوني',
      professionalJobTitleText: 'صيدلي (ممنوح في جمهورية ألمانيا الاتحادية وكذلك في الجمهورية العربية السورية)',
      professionalAuthority: 'الغرفة المختصة',
      professionalAuthorityText: 'Bayerische Landesapothekerkammer, Maria-Theresia-Straße 28, 81675 München, Deutschland',
      professionalAuthorityWebsite: 'www.blak.de',
      professionalSupervisoryAuthority: 'الجهة الرقابية المختصة',
      professionalSupervisoryAuthorityText: 'Regierung von Mittelfranken, Promenade 27, 91522 Ansbach',
      professionalRegulations: 'اللوائح المهنية',
      professionalRegulationsName: 'Berufsordnung für Apotheker',
      professionalRegulationsText: '(يمكن الاطلاع عليها عبر الموقع الإلكتروني لنقابة الصيادلة المختصة).'
    },
    privacy: {
      title: 'سياسة الخصوصية',
      section1Title: 'الجهة المسؤولة وبيانات التواصل',
      section1Text: 'الاسم: Sami Chalhoub\nالعنوان: Mohrenstraße 5, 90762 Fürth, Deutschland\nالبريد الإلكتروني: sami.chalhoub@chalhoubtrade.de\nالهاتف: \u200E+4915226573461\u200E',
      section2Title: 'توفير الموقع والأمان',
      section2Text: 'يستخدم هذا الموقع تشفير SSL/TLS لأسباب أمنية ولحماية نقل المحتوى السري.\n\nيتم استضافة هذا الموقع خارجياً. يقوم مزوّد الاستضافة تلقائياً بحفظ ملفات سجلّ الخادم (عنوان IP، نوع المتصفح، الطابع الزمني).\n\nنستخدم فقط ملفات تعريف الارتباط الضرورية تقنياً لتشغيل الموقع (لا يوجد تسويق/تتبّع).\n\nالأساس القانوني: (\u200EArt. 6 Abs. 1 lit. f DSGVO\u200E).',
      section3Title: 'استخدام البيانات والتخزين',
      section3Text: 'تتم معالجة البيانات في حال طلبات التواصل على أساس (\u200EArt. 6 Abs. 1 lit. b DSGVO\u200E).\n\nيتم الاحتفاظ بالبيانات فقط طالما كان ذلك ضرورياً لغرض المعالجة أو وفقاً لالتزامات الاحتفاظ القانونية.',
      section4Title: 'حقوقك وطريق الشكوى',
      section4Text: 'لديك حق الوصول إلى بياناتك وتصحيحها وحذفها، وكذلك حق تقييد المعالجة، وحق قابلية نقل البيانات، وحق الاعتراض.\n\nلديك أيضاً الحق في تقديم شكوى إلى الجهة الرقابية المختصة. والجهة المختصة على وجه الخصوص هي: Bayerisches Landesamt für Datenschutzaufsicht (\u200EBayLDA\u200E).'
    },
    footer: {
      slogan: 'نربط الصحة عالمياً',
      description: 'استشارات دوائية احترافية وحلول توريد عالمية من ألمانيا\u200F.',
      quickLinks: 'روابط سريعة',
      contactInfo: 'معلومات التواصل',
      addressText: 'Mohrenstrasse 5\n90762 Fuerth\nGermany',
      copyright: '©',
      allRights: 'جميع الحقوق محفوظة.'
    }
  },
  de: {
    nav: {
      services: 'Leistungen',
      whyUs: 'Warum wir',
      contact: 'Kontakt',
      imprint: 'Impressum',
      privacy: 'Datenschutz'
    },
    hero: {
      badge: 'Pharmazeutische Beratung',
      title: 'Chalhoub Trade',
      subtitle: 'Gesundheit weltweit verbinden',
      description: 'Professionelle pharmazeutische Beratung und Sourcing-Expertise aus Deutschland. Als strategischer Vermittler eröffnen wir globalen Gesundheitsdienstleistern, insbesondere in der MENA-Region, den Zugang zu hochwertigen deutschen Arzneimitteln und Medizinprodukten.',
      cta: 'Machbarkeitsprüfung anfragen',
      disclaimer: 'Chalhoub Trade agiert ausschließlich als unabhängiger Arzneimittelvermittler und kauft, verkauft, lagert oder versendet keine Arzneimittel.'
    },
    services: {
      title: 'Unsere Kerndienstleistungen',
      subtitle: 'Umfassende pharmazeutische Beratung und Supply-Chain-Lösungen, maßgeschneidert auf Ihre Bedürfnisse.',
      service1: {
        title: 'Sourcing & Vermittlung deutscher Arzneimittel',
        description: 'Wir sind spezialisiert auf die Vermittlung hochwertiger, in Deutschland hergestellter Arzneimittel und Medizinprodukte. Durch unser Netzwerk zu GDP-zertifizierten Herstellern und Großhändlern eröffnen wir internationalen Gesundheitsdienstleistern den direkten Zugang zu Originalmedikamenten und innovativen medizinischen Lösungen, ohne Umwege.',
        features: [
          'Zugang zu deutschen Marken: Direkte Vermittlung authentischer Produkte aus dem deutschen Markt an internationale Importeure.',
          'Verhandlungsführung: Sicherung wettbewerbsfähiger Konditionen durch professionelle pharmazeutische Expertise und Marktkenntnis.',
          'Lieferanten-Verifizierung: Sicherstellung, dass alle Handelspartner die höchsten europäischen Sicherheitsstandards und Lizenzen erfüllen.'
        ]
      },
      service2: {
        title: 'Regulierungs- und Compliance-Beratung',
        description: 'Der internationale Pharmahandel unterliegt komplexen rechtlichen Rahmenbedingungen. Wir bieten fachkundige Beratung, um sicherzustellen, dass jede Transaktion vollständig mit den deutschen Exportgesetzen und internationalen sowie lokalen Importvorschriften übereinstimmt.',
        features: [
          'Dokumentenmanagement: Erstellung von Ursprungszeugnissen (CO), Analysezertifikaten (CoA), CPP und Ausfuhranmeldungen zur Gewährleistung einer reibungslosen Zollabwicklung im Bestimmungsland.',
          'Markteintrittsunterstützung: Beratung zu lokalen Registrierungsanforderungen und regulatorischen Hürden.',
          'Lieferanten-Verifizierung: Sicherstellung, dass alle Handelspartner die höchsten europäischen Sicherheitsstandards und Lizenzen erfüllen (GDP/GMP-Compliance Check).'
        ]
      },
      service3: {
        title: 'Supply Chain Koordination & Logistik-Überwachung',
        description: 'Ein Medikament ist nur dann wirksam, wenn es sicher ankommt. Wir koordinieren die sensible Logistik des internationalen Pharmatransports durch die Auswahl zertifizierter Partner. Unser Fokus liegt auf der Überwachung der Lieferkette vom Hersteller bis zum Endziel, um höchste Standards sicherzustellen.',
        features: [
          'Kühlketten-Integrität: Überwachung der Temperaturanforderungen (2-8°C / 15-25°C) durch spezialisierte, GDP-konforme Logistikpartner.',
          'Incoterm-Optimierung: Beratung zu idealen Versandbedingungen (FCA, CPT, DAP), um Kosten und Risiko effizient zwischen Käufer und Verkäufer zu balancieren.',
          'Inspektions-Management: Beauftragung und Koordination unabhängiger Vorversandkontrollen durch internationale Agenturen (z.B. SGS, Bureau Veritas) im Auftrag des Kunden.'
        ]
      }
    },
    whyPartner: {
      title: 'Warum mit Chalhoub Trade zusammenarbeiten?',
      subtitle: 'Chalhoub Trade agiert als spezialisierte Schnittstelle zwischen deutschen Exporteuren und internationalen Gesundheitsversorgern. Wir handeln nicht mit Ware, wir handeln mit Lösungen: Wir identifizieren Bezugsquellen, prüfen die regulatorische Machbarkeit und koordinieren den Prozess für Sie.',
      reason1: {
        title: 'Apotheker-geführte Expertise',
        description: 'Als in Deutschland und Syrien approbierter Apotheker bietet Sami Chalhoub ein Maß an regulatorischer und pharmazeutisch-rechtlicher Einsicht, das Standard-Handelsunternehmen nicht bieten können.'
      },
      reason2: {
        title: 'Der „Made in Germany" Vorteil',
        description: 'Mit Sitz in Fürth operieren wir in einem der weltweit am strengsten regulierten und angesehensten pharmazeutischen Umfelder.'
      },
      reason3: {
        title: 'Zuverlässigkeit & Transparenz',
        description: 'Wir bauen langfristige Partnerschaften auf Basis ethischer Geschäftspraktiken und klarer, serviceorientierter Kommunikation auf.'
      },
      reason4: {
        title: 'Globale Vision',
        description: 'Unsere Mission ist es, die Brücke zwischen europäischer medizinischer Exzellenz und globalen Gesundheitsbedürfnissen zu schlagen. Unser besonderer Fokus liegt dabei auf der MENA-Region.'
      },
      compliance: 'Alle Projekte werden fallbezogen geprüft. Wir führen EU Sanktionsprüfungen, KYC Prüfungen und Endverwendungsprüfungen für alle beteiligten Parteien durch.',
      scope: 'Wir konzentrieren uns auf fertige Arzneimittel und unterstützen keine kontrollierten Substanzen, dual use sensiblen Güter oder Umgehungskonstruktionen.'
    },
    contact: {
      title: 'Machbarkeitsprüfung',
      subtitle: 'Für eine erste Prüfung bitten wir Sie, die untenstehenden Angaben anzugeben.',
      address: 'Adresse',
      addressValue: 'Mohrenstraße 5, 90762 Fürth, Deutschland',
      phone: 'Telefon',
      email: 'E-Mail',
      feasibilityLink: 'Machbarkeitsprüfung anfragen',
      checklistItems: [
        'Zielland und Stadt',
        'Importeur Typ und Firmenname',
        'Kurze Produktliste, bis zu 10 Artikel',
        'Erwartete Menge und bevorzugte Währung'
      ],
      languageDisclaimer: 'Englisch wird für die Erstprüfung bevorzugt.'
    },
    imprint: {
      title: 'Impressum',
      responsible: 'Verantwortlich',
      contact: 'Kontaktinformationen',
      tax: 'Steuerinformationen',
      vatLabel: 'USt-IdNr',
      dispute: 'Streitbeilegung',
      disputeConsumerLabel: 'Verbraucherstreitbeilegung',
      disputeConsumerText: 'Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.',
      professional: 'Berufsrechtliche Angaben',
      professionalJobTitle: 'Gesetzliche Berufsbezeichnung',
      professionalJobTitleText: 'Apotheker (verliehen in der Bundesrepublik Deutschland sowie in der Syrischen Arabischen Republik)',
      professionalAuthority: 'Zuständige Kammer',
      professionalAuthorityText: 'Bayerische Landesapothekerkammer, Maria-Theresia-Straße 28, 81675 München, Deutschland',
      professionalAuthorityWebsite: 'www.blak.de',
      professionalSupervisoryAuthority: 'Zuständige Aufsichtsbehörde',
      professionalSupervisoryAuthorityText: 'Regierung von Mittelfranken, Promenade 27, 91522 Ansbach',
      professionalRegulations: 'Berufsrechtliche Regelungen',
      professionalRegulationsText: 'Berufsordnung für Apotheker (einzusehen auf der Website der zuständigen Apothekerkammer).'
    },
    privacy: {
      title: 'Datenschutzerklärung',
      section1Title: 'Verantwortlicher & Kontakt',
      section1Text: 'Sami Chalhoub\nMohrenstraße 5, 90762 Fürth, Deutschland\nE-Mail: sami.chalhoub@chalhoubtrade.de\nTelefon: +49 152 2657 3461',
      section2Title: 'Bereitstellung der Website & Sicherheit',
      section2Text: 'Diese Website nutzt eine SSL- bzw. TLS-Verschlüsselung zur Sicherheit und zum Schutz der Übertragung vertraulicher Inhalte.\n\nDie Website wird extern gehostet. Der Host-Provider speichert automatisch Server-Log-Files (IP-Adresse, Browsertyp, Zeitstempel).\n\nEs werden ausschließlich technisch notwendige Cookies eingesetzt (kein Marketing/Tracking).\n\nRechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO.',
      section3Title: 'Datennutzung & Speicherung',
      section3Text: 'Daten im Rahmen von Kontaktanfragen werden auf Basis von Art. 6 Abs. 1 lit. b DSGVO verarbeitet.\n\nDie Speicherung erfolgt nur so lange, wie dies für den Zweck erforderlich ist oder gesetzlich vorgeschrieben (Aufbewahrungsfristen).',
      section4Title: 'Ihre Rechte & Beschwerdeweg',
      section4Text: 'Sie haben das Recht auf Auskunft, Berichtigung und Löschung sowie das Recht auf Einschränkung der Verarbeitung, das Recht auf Datenübertragbarkeit und ein Widerspruchsrecht.\n\nSie haben zudem das Recht, sich beim Bayerischen Landesamt für Datenschutzaufsicht (BayLDA) zu beschweren.'
    },
    footer: {
      slogan: 'Gesundheit Weltweit verbinden',
      description: 'Premium pharmazeutische Beratung und globale Beschaffungslösungen aus Deutschland.',
      quickLinks: 'Schnelllinks',
      contactInfo: 'Kontaktinformationen',
      addressText: 'Mohrenstraße 5\n90762 Fürth\nDeutschland',
      copyright: '©',
      allRights: 'Alle Rechte vorbehalten.'
    }
  }
};
